/**
 * @file index.tsx
 *
 * @fileoverview Renders the title for the search pages that have SEO Search Content. Handles check for displaying
 * SEO Search content or the metatags depending on the response.
 */
import React from 'react';
import SearchTitle from '~/jobiqo/components/Search/search-title';
import { BlogSearchResult } from '~/jobiqo/models/blog';
import {
  Metatag,
  SearchApiJobResult,
  SearchApiOrganizationProfileResult,
} from '~/jobiqo/types/types';

interface SEOSearchTitleProps {
  /**
   * The result of the search query for blogs.
   */
  searchResult:
    | BlogSearchResult
    | SearchApiJobResult
    | SearchApiOrganizationProfileResult;
  /**
   * Wether or not to show a header wrapping tag.
   *
   * @default true
   */
  showHeaderTag?: boolean;
  /**
   * The default translated title type (e.g. article, job).
   */
  title: string;
}

export default function SEOSearchTitle({
  searchResult,
  showHeaderTag = true,
  title,
}: SEOSearchTitleProps) {
  const SEOSearchContentTitle = searchResult?.seoSearchContent?.title;
  // If there is a banner image and a SEOSearchContentTitle then we already showed it.
  // In that case we should here the metatags default title (e.g. 4 Full time jobs).
  const showMetatagTitle =
    SEOSearchContentTitle && searchResult?.seoSearchContent?.headerImage;
  // If the title was already displayed in the banner as h1 we display as h2 here.
  const TitleTag = showHeaderTag
    ? SEOSearchContentTitle && searchResult?.seoSearchContent?.headerImage
      ? 'h2'
      : 'h1'
    : 'span';

  return (
    <TitleTag>
      {SEOSearchContentTitle && !showMetatagTitle ? (
        SEOSearchContentTitle
      ) : (
        <SearchTitle
          metadata={searchResult?.metatags as Metatag[]}
          type={title}
          amount={searchResult.result_count ?? 0}
        />
      )}
    </TitleTag>
  );
}
